var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpcomingPayoutAmountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0862 0.492188H1.47266V1.22839H22.0862V0.492188Z",
    fill: "#3876BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5583 2.1543H0V14.4915H23.5583V2.1543ZM22.8222 13.7546H0.736198V2.8905H22.8222V13.7546Z",
    fill: "#3876BB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 3.85742V5.79878L3.75703 3.85742H1.81641Z",
    fill: "#3876BB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81641 10.8477V12.789H3.75703L1.81641 10.8477Z",
    fill: "#3876BB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7414 3.85742H19.8008L21.7414 5.79878V3.85742Z",
    fill: "#3876BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7414 10.8477L19.8008 12.789H21.7414V10.8477Z",
    fill: "#3876BB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0556 5.83871L14.9013 4.86914L11.1526 9.27676L9.5771 7.79406L8.53906 8.88437L11.2748 11.4596L16.0556 5.83871Z",
    fill: "#3876BB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingPayoutAmountIcon);
export default __webpack_public_path__ + "static/media/UpcomingPayoutAmountIcon.b1048dc4fe3c106bd35d8604c99e0b3f.svg";
export { ForwardRef as ReactComponent };